export const state = {
    keywordList: [],
};

export const getters = {
    keywordList: state => state.keywordList,
};

export const mutations = {
    addKeyword(state, newValue) {
        if (state.keywordList.findIndex(item => item === newValue) < 0) {
            state.keywordList.push(newValue)
        }
    },
    removeKeyword(state, value) {
        const foundIdx = state.keywordList.findIndex(item => item === value)

        if (foundIdx > -1) {
            state.keywordList.splice(foundIdx, 1)
        }
    },
    clearKeywords(state) {
        state.keywordList = []
    }
};

export const actions = {
    addKeyword({commit}, keyword) {
        commit('addKeyword', keyword)
    },
    removeKeyword({commit}, keyword) {
        commit('removeKeyword', keyword)
    },
    clearKeywords({commit}) {
        commit('clearKeywords')
    },
};
